const KeenSlider = window.KeenSlider

const { addWheelControls, useArrows } = window.BAO.Carousel.plugins

class FiftyFiftyCollectionSlider extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 3.15,
          spacing: 10,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 3.15,
              spacing: 10,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 3.15,
              spacing: 10,
            },
          },
        },
      },
      [
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
      [addWheelControls('horizontal')],
    )
  }
}

if (!customElements.get('fiftyfifty-collection-slider')) {
  customElements.define(
    'fiftyfifty-collection-slider',
    FiftyFiftyCollectionSlider,
  )
}
